import styled from 'styled-components';
import { SearchBox } from '@fluentui/react';

export const TeamWidgetSearchBox = styled(SearchBox)`
  width: 182px;
  display: flex;
  flex-direction: row-reverse;
  background-color: ${(props) => props.theme.mainBackgorund};
  padding-left: 10px;
  font-size: 14px;
  position: absolute;
  top: 0.15rem;
  right: 0.5rem;

  .ms-SearchBox-field {
    color: ${(props) => props.theme.inputTextColor};

    ::placeholder {
      color: ${(props) => props.theme.inputTextColor};
    }
  }

  i.ms-SearchBox-icon {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    color: ${(props) => props.theme.inputTextColor};

    &:hover {
      color: ${(props) => props.theme.inputTextColor};
    }
  }

  .ms-SearchBox-clearButton {
    position: absolute;
    top: 9px;
    right: 0;
    background: ${(props) => props.theme.mainBackgorund};

    [class*='root-']:hover {
      background: ${(props) => props.theme.mainBackgorund};
    }

    .ms-Icon {
      color: ${(props) => props.theme.inputTextColor};
    }
  }

  @media (max-width: 710px) {
    font-size: 16px;
  }
`;
